<template>
<!-- 
  Author: lan.h
  Date: 2021-10-18
  content: 报告下载 
-->
  <div class="vb100" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="p_head">
      <div class="p_title">
        <p>REPORT</p>
        <h1>报告下载</h1>
      </div>
      <div class="p_links">
        <div class="links-item js-lower-anchor" v-for="item, index in report_type" :key="index" @click="categoryChange(item)">
          <p class="links-name" :class="params.category_id == item.id ? 'active' : ''">{{item.name}}</p>
        </div>
      </div>
    </div>
    <div class="report-content">
      <el-dropdown placement="bottom-start" @command="tagChange">
        <span class="el-dropdown-link">
          {{params.tag_id | dealNeed(tag_list, 'name', '全部')}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="''">全部</el-dropdown-item>
          <el-dropdown-item :command="item.id" v-for="item in  tag_list" :key="item.id">{{item.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <ul class="report-ul">
        <li v-for="item, index in report_list" :key="index">
          <div class="report_img">
            <img :src=" $store.state.img_req_url + item.logo_path" />
          </div>
          <div class="report-right">
            <a v-if="item.file_path" :href=" $store.state.img_req_url + item.file_path" target="_blank"><h1 class="over-p2">{{item.title}}</h1></a>
            <a v-else><h1 class="over-p2">{{item.title}}</h1></a>
            <p class="over-p2">{{item.summary}}</p>
            <div class="time">{{item.publish_time | time_deal}}</div>
          </div>
        </li>
      </ul>
      <el-empty :image-size="200" v-if="report_list.length == 0"></el-empty>
      <div class="layout-page" v-if="total > 10">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getReportTag, getReportList } from '@/service/main.js'
export default {
  data() {
    return {
      loading: false,
      report_type: [
        {id:'', name: '全部'},
        {id:'3', name:'百强企业成长报告'},
        {id:'5', name:'季度、年度投融资报告'},
        {id:'7', name:'细分领域研究报告'}
      ],
      params: {
        category_id: '',
        tag_id: '',
        page: 1
      },
      total: 0,
      report_list: [],
      tag_list: []
    }
  },
  created() {
    this.getReportTag()
    this.getReportList()
  },
  methods: {
    async getReportTag() {
      let res = await getReportTag({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.$set(this.$data, 'tag_list', res.res)
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getReportList() {
      this.loading = true
      let res = await getReportList( this.params, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.$set(this.$data, 'report_list', res.res)
        this.total = res.count
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    categoryChange(item) {
      this.params.category_id = item.id 
      this.params.page = 1
      this.getReportList()
    },
    tagChange(val) {
      this.params.tag_id = val
      this.params.page = 1
      this.getReportList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getReportList()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/main/list.stylus';
.p_head
  width 1200px
  margin 0 auto
  .p_links
    right 0
    .links-item
      height 30px
      .active
        color #D9BB9E
.report-content
  width 1200px
  margin 30px auto 0
  .report-ul
    display flex 
    flex-flow row wrap
    margin-top 20px
    li 
      width 50%
      display flex 
      flex-flow row wrap
      margin-top 40px
      .report_img
        width 200px
        height 120px
        img 
          width 100%
          height 100%
      .report-right
        width calc(100% - 200px)
        padding-left 15px
        padding-right 18px
        a
          display block
          height 40px
          h1 
            font-size 18px
            font-weight 800
            color #FFFFFF
            line-height 20px
            cursor pointer
            &:hover 
              color #D9BB9E
        p 
          font-size 14px
          font-weight 500
          color #BCBDC1
          line-height 20px
          margin-top 10px
          height 40px
        .time
          margin-top 15px
          color #BCBDC1
    li:nth-child(1), li:nth-child(2)
      margin-top 0
.vb100 
  padding-bottom 40px
</style>